import { Visibility, VisibilityOff } from "@mui/icons-material";
import React, { useEffect, useRef, useState } from "react";
import { CircularProgress } from "@mui/material";
import { auth } from "../firebase"; // Ensure correct path to firebase.js

const SignIn = ({ history }) => {
  const emailRef = useRef();
  const passwordRef = useRef();
  const [error, setError] = useState({
    email: false,
    password: false
  });

  const [errorMessage, setErrorMessage] = useState("");
  const [loading, setLoading] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const handleClickShowPassword = () => setShowPassword(!showPassword);

  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth < 768);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, [isMobile]);

  useEffect(() => {
    // Redirect if already authenticated
    if (localStorage.getItem("isAuthenticated") === "true") {
      const role = localStorage.getItem("userRole");
      redirectBasedOnRole(role);
    }
  }, [history]);

  const redirectBasedOnRole = role => {
    if (role === "Admin") {
      history.push("/home");
    } else if (role === "Expert") {
      history.push("/feedback/summary");
    } else if (role === "superAdmin") {
      history.push("/home");
    } else {
      history.push("/home");
    }
  };

  async function handleSubmit(e) {
    e.preventDefault();
    const email = emailRef.current && emailRef.current.value;
    const password = passwordRef.current && passwordRef.current.value;
    if (!email && !password) {
      setErrorMessage("Email and Password Cannot be Empty");
      setError(prev => ({ ...prev, email: true, password: true }));
      return;
    } else if (!email) {
      setErrorMessage("UserName Cannot be Empty");
      setError(prev => ({ ...prev, password: false, email: true }));
      return;
    } else if (!password) {
      setError(prev => ({ ...prev, email: false, password: true }));
      setErrorMessage("Password Cannot be Empty");
      return;
    }

    try {
      setLoading(true);
      const userCredential = await auth.signInWithEmailAndPassword(
        email,
        password
      );
      const user = userCredential.user;

      // Get user token
      const token = await user.getIdToken(true); // Force refresh token
      const tokenResult = await user.getIdTokenResult(); // Fetch role from Firebase custom claims

      let role = "user";
      if (tokenResult && tokenResult.claims["superAdmin"]) {
        role = "superAdmin";
      } else if (tokenResult && tokenResult.claims["Admin"]) {
        role = "Admin";
      } else if (tokenResult && tokenResult.claims["Expert"]) {
        role = "Expert";
      }
      localStorage.setItem("isAuthenticated", "true");
      localStorage.setItem("userToken", token); // Store token
      localStorage.setItem("name", user.displayName || "User"); // Fallback if displayName is null
      localStorage.setItem("userRole", role); // Store token if needed
      window.dispatchEvent(new Event("storage"));
      redirectBasedOnRole(role);
    } catch {
      setErrorMessage("Some Error Occurred , Please Try Again Later");
      setError(prev => ({ ...prev, email: false, password: false }));
    } finally {
      setLoading(false);
    }
  }
  const features = [
    {
      title: "Real-Time Soil Monitoring",
      description:
        "Captures and streams data for parameters like soil moisture, pH, temperature, NPK, EC, and more—ensuring timely and condition-aware decisions.",
      icon: "/npk_monitoring_shm_icon.svg"
    },
    {
      title: "AI-Based Fertilizer Recommendations",
      description:
        "Generates crop- and soil-specific dosage recommendations using machine learning models, constantly updated through expert validation and real-world use cases.",
      icon: "/ai_based_fertilizer_shms_icon.svg"
    },
    {
      title: "SHC Integration & Expert Advisory",
      description:
        "Farmers can upload Soil Health Cards via mobile or web and receive AI-analyzed fertilizer suggestions, with optional expert consultations for personalized nutrient planning.",
      icon: "/shc_integation_shms_icon.svg"
    }
  ];

  return (
    <div style={{ width: "100%", height: "100vh", display: "flex" }}>
      <div style={{ position: "fixed",
    top: 0,
    left: 0,
    width: "50%",
    height: "100vh",
    display: "flex"}}>
        <div style={{ width: "100%", height: "100vh" }}>
          <img
            src="/agrim_login.png"
            alt="Dashboard Illustration"
            style={{ width: "100%", height: "100%", objectFit: "cover" }}
          />
        </div>
        <div
          style={{
            position: "relative",
            flex: 1,
            height: "auto",
            backgroundColor: "#000",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            gap: "1.87rem"
          }}
        >
          <div
            style={{
              position: "absolute",
              top: "10rem",
              width: "20rem",
              height: "20rem",
              backgroundImage: 'url("/Background.png")',
              backgroundSize: "cover",
              backgroundRepeat: "no-repeat",
              transform: "rotate(-45deg)",
              opacity: 0.25,
              zIndex: 0,
              pointerEvents: "none"
            }}
          ></div>
          {/* <p
            style={{
              margin: 0,
              color: "#FFF",
              fontFamily: "TASA Explorer",
              fontSize: "2.25rem",
              fontStyle: "normal",
              fontWeight: 600,
              lineHeight: "normal",
              letterSpacing: "0.0225rem",
              marginTop: "2rem"
            }}
          >
            AgriPulse
          </p> */}
          <div
            style={{
              marginTop: "5rem",
              width: "23.5625rem",
              paddingTop: "1.75rem",
              paddingBottom: "1.75rem",
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              flexShrink: 0,
              fill: "rgba(22, 21, 21, 0.85)",
              strokeWidth: "",
              stroke: "rgba(255, 255, 255, 0.16)",
              boxShadow:
                "0px 3.606px 16.227px 0px rgba(131, 131, 131, 0.08) inset",
              backdropFilter: "blur(3.5px)",
              position: "relative",
              border: "1px solid rgba(255, 255, 255, 0.16)",
              borderRadius: "1.352rem"
            }}
          >
            <img
              src="/Agrim.png"
              alt=""
              style={{
                width: "14.8125rem",
                height: "6.75rem",
                flexShrink: 0,
                objectFit: "cover"
              }}
            />
            
            <div
              style={{
                textAlign: "left",
                width: "19.9375rem",
                display: "flex",
                flexDirection: "column",
                gap: "0.5rem"
              }}
            >
              <p
                style={{
                  margin: 0,
                  color: "rgba(255, 255, 255, 0.90)",
                  fontFamily: "Inter, sans-serif",
                  fontSize: "1.01419rem",
                  fontStyle: "normal",
                  fontWeight: 600,
                  lineHeight: "normal",
                  marginTop: "2.75rem"
                }}
              >
                UserName
              </p>
              <input
                type="email"
                style={{
                  display: "flex",
                  color: "#FFF",
                  padding: "1.35219rem",
                  justifyContent: "space-between",
                  alignItems: "center",
                  flexShrink: 0,
                  borderRadius: "0.45075rem",
                  border: error["email"]
                    ? "1px solid #FF4C4C"
                    : "0.901px solid rgba(255, 255, 255, 0.14)",
                  background: "#151515"
                }}
                onChange={() => {
                  setErrorMessage("");
                  setError(prev => ({
                    ...prev,
                    email: false,
                    password: false
                  }));
                }}
                ref={emailRef}
              />
            </div>
            <div
              style={{
                textAlign: "left",
                width: "19.9375rem",
                display: "flex",
                flexDirection: "column",
                gap: "0.5rem"
              }}
            >
              <p
                style={{
                  margin: 0,
                  color: "rgba(255, 255, 255, 0.90)",
                  fontFamily: "Inter, sans-serif",
                  fontSize: "1.01419rem",
                  fontStyle: "normal",
                  fontWeight: 600,
                  lineHeight: "normal",
                  marginTop: "2.19rem"
                }}
              >
                Password
              </p>

              <div style={{ position: "relative", width: "100%" }}>
                <input
                  ref={passwordRef}
                  type={showPassword ? "text" : "password"}
                  onChange={() => {
                    setErrorMessage("");
                    setError(prev => ({
                      ...prev,
                      email: false,
                      password: false
                    }));
                  }}
                  style={{
                    width: "100%",
                    padding: "1.35219rem",
                    paddingRight: "3rem", // extra space for the icon
                    color: "#FFF",
                    borderRadius: "0.45075rem",
                    border: error["password"]
                      ? "1px solid #FF4C4C"
                      : "0.901px solid rgba(255, 255, 255, 0.14)",
                    background: "#151515",
                    boxSizing: "border-box"
                  }}
                />
                <span
                  onClick={handleClickShowPassword}
                  style={{
                    position: "absolute",
                    top: "50%",
                    right: "1rem",
                    transform: "translateY(-50%)",
                    cursor: "pointer",
                    color: "#FFF"
                  }}
                >
                  {showPassword ? <Visibility /> : <VisibilityOff />}
                </span>
              </div>
            </div>

            {errorMessage.length > 0 && (
              <div
                style={{
                  color: "#FF4C4C",
                  fontSize: "0.875rem",
                  fontWeight: 500,
                  marginTop: "0.5rem",
                  width: "19.9375rem"
                }}
              >
                {errorMessage}
              </div>
            )}

            <button
              onClick={handleSubmit}
              type="submit"
              style={{
                width: "8.11331rem",
                height: "2.70444rem",
                flexShrink: 0,
                borderRadius: "0.45075rem",
                border: "1.352px solid rgba(227, 133, 0, 0.80)",
                background: "rgba(227, 133, 0, 0.07)",
                color: "#E38500",
                textAlign: "center",
                fontFamily: '"TASA Explorer", sans-serif',
                fontSize: "0.67613rem",
                fontStyle: "normal",
                fontWeight: 600,
                lineHeight: "normal",
                letterSpacing: "0.0135rem",
                cursor: "pointer",
                marginTop: "1.5rem"
              }}
            >
              {loading ? (
                <CircularProgress
                  size="1rem"
                  thickness={5}
                  sx={{
                    color: "#E38500",
                    margin: "0 auto"
                  }}
                />
              ) : (
                "Sign In"
              )}
            </button>
          </div>
        </div>
      </div>
      <div
        style={{
          paddingLeft: "55%",
          paddingTop: "2rem",
          paddingBottom: "3rem",
          height: "150vh",
          maxWidth: "100%",
          justifyContent: "center",
          backgroundColor: "#000"
        }}
      >
        <h2
          style={{
            fontSize: "26px",
            fontWeight: "600",
            marginBottom: "6px",
            color: "#fff",
            textAlign: "center"
          }}
        >
          Soil Health Monitoring System
        </h2>

        <p
          style={{
            fontSize: "15px",
            color: "#fff",
            marginBottom: "24px",
            // maxWidth: "75%",
            textAlign: "center",
            width: "90%"
          }}
        >
          The Soil Health Monitoring System gives farmers real-time soil
          insights and AI-based fertilizer advice. With IoT sensors, expert
          support, feedback-driven AI updates, and multilingual access via
          AgriPulse, it brings precision to modern farming.
        </p>
        <h3
          style={{
            color: "#fff",
            textAlign: "center"
          }}
        >
          Features
        </h3>

        {features.map((obj, index) => {
          if (index % 2 == 0) {
            return (
              <div
                style={{
                  display: "flex",
                  flexDirection: "row",
                  gap: "5rem",
                  alignItems: "center",
                  justifyContent: "center"
                }}
              >
                <div
                  style={{
                    width: "10rem",
                    height: "10rem",
                    flexShrink: 0

                    // borderRadius: "1rem"
                    //backgroundColor: "grey",
                  }}
                >
                  <img
                    src={obj.icon}
                    alt=""
                    style={{
                      objectFit: "cover",
                      width: "100%",
                      // padding: "1.7rem"
                    }}
                  />
                </div>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    gap: "0.5rem",
                    textAlign: "left"
                  }}
                >
                  <p
                    style={{
                      margin: 0,
                      color: "#FFF",
                      fontFamily: "TASA Explorer",
                      fontSize: "1rem",
                      fontStyle: "normal",
                      fontWeight: 500,
                      lineHeight: "106.59%",
                      letterSpacing: "0.04375rem"
                    }}
                  >
                    {obj.title}
                  </p>
                  <p
                    style={{
                      margin: 0,
                      width: "15.5rem",
                      color: "#fff",
                      fontFamily: "TASA Explorer",
                      fontSize: "0.8rem",
                      fontStyle: "normal",
                      fontWeight: 400,
                      lineHeight: "148%",
                      letterSpacing: "0.0225rem"
                    }}
                  >
                    {obj.description}
                  </p>
                </div>
              </div>
            );
          } else {
            return (
              <div
                style={{
                  display: "flex",
                  flexDirection: "row",
                  gap: "5rem",
                  alignItems: "center"
                }}
              >
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    gap: "0.5rem",
                    textAlign: "left"
                  }}
                >
                  <p
                    style={{
                      margin: 0,
                      color: "#fff",
                      fontFamily: "TASA Explorer",
                      fontSize: "1rem",
                      fontStyle: "normal",
                      fontWeight: 500,
                      lineHeight: "106.59%",
                      letterSpacing: "0.04375rem"
                    }}
                  >
                    {obj.title}
                  </p>
                  <p
                    style={{
                      margin: 0,
                      width: "15.5rem",
                      color: "#fff",
                      fontFamily: "TASA Explorer",
                      fontSize: "0.8rem",
                      fontStyle: "normal",
                      fontWeight: 400,
                      lineHeight: "148%",
                      letterSpacing: "0.0225rem"
                    }}
                  >
                    {obj.description}
                  </p>
                </div>
                <div
                  style={{
                    width: "10rem",
                    height: "10rem",
                    flexShrink: 0
                    // borderRadius: "1rem"
                    // backgroundColor: "grey",
                  }}
                >
                  <img
                    src={obj.icon}
                    alt=""
                    style={{
                      objectFit: "cover",
                      width: "100%",
                      // padding: "1.7rem",
                    }}
                  />
                </div>
              </div>
            );
          }
        })}
      </div>
    </div>
  );
};

export default SignIn;
